import React from 'react';
import { useLabels } from 'wsm-common-data';
import PropTypes from 'prop-types';
import RemoveButton from './common/RemoveButton';

const StickyCard = ({ vehicle, cardWidth, showRemoveButton }) => {
	const { title = [], pricing = {}, uuid } = vehicle;
	const { dprice = [] } = pricing;
	const finalPrice = dprice?.find((item) => item?.isFinalPrice);
	const labels = useLabels();
	return (
		<div
			className="border border-radius-sm p-3 px-lg-4 ddc-font-size-small"
			style={{ width: `${cardWidth}px` }}
		>
			<div className="d-flex justify-content-between">
				<div className="pt-1">
					<div className="font-weight-normal">{title.join(' ')}</div>
					<div className="font-weight-bold">
						{finalPrice?.value || labels.get('PLEASE_CALL')}
					</div>
				</div>
				{showRemoveButton && <RemoveButton uuid={uuid} />}
			</div>
		</div>
	);
};

StickyCard.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		images: PropTypes.arrayOf(
			PropTypes.shape({
				uri: PropTypes.string,
				title: PropTypes.string,
				alt: PropTypes.string
			})
		),
		pricing: PropTypes.shape({
			dprice: PropTypes.arrayOf(
				PropTypes.shape({
					isFinalPrice: PropTypes.bool
				})
			)
		}),
		uuid: PropTypes.string.isRequired
	}),
	cardWidth: PropTypes.number.isRequired,
	showRemoveButton: PropTypes.bool.isRequired
};

export default StickyCard;
